<template>
    <v-col cols="12" lg="4" md="6" sm="12">
      <!-- fill-height keeps cards in a row the same height whatever content
           they carry, so a card without an image does not leave a gap. -->
      <v-card dense :loading="loading" class="fill-height d-flex flex-column">
        <v-card-title class="mx-0 mt-0 mb-2 px-0 pb-0 pt-1 border-top-purple event-card__title-wrap">
                <Link
                  :href="baseurl+'/event/'+event.alias"
                  :title="event.title"
                  class="px-4 py-5 event-card__title-link"
                >
                  <span class="event-card__title">{{ event.title }}</span>
                </Link>
        </v-card-title>
            <!-- Fixed-height band so every card lines up whatever shape the
                 poster is, with a placeholder when no image was uploaded. -->
            <v-card-text class="pb-0">
                <v-img
                    v-if="event.photo_path"
                    :src="baseurl + '/img/' + event.photo_path"
                    height="220"
                    contain
                    class="event-card__image"
                >
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
                <div v-else class="event-card__image event-card__image--empty d-flex align-center justify-center">
                    <v-icon size="56" color="primary">mdi-calendar-star</v-icon>
                </div>
            </v-card-text>
            <v-card-actions class="px-4">
                <v-row>
                                    <v-col cols="12" md="10" sm="12" class="bottom-border-purple">
                                        <span class="text-h5">Event Details</span>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.start_date">
                                        <span class="text-lg-h6"><v-icon left>mdi-calendar</v-icon>Date</span>
                                        <p><span>{{ prettyDate(event.start_date) }}</span><span v-if="event.end_date && event.end_date != event.start_date"> - {{ prettyDate(event.end_date) }}</span></p>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.start_time">
                                        <span class="text-lg-h6"><v-icon left>mdi-clock</v-icon>Time</span>
                                        <p><span>{{ prettyTime(event.start_time) }}</span><span v-if="event.end_time"> - {{ prettyTime(event.end_time) }}</span></p>
                                    </v-col>
                                    
                                    <v-col cols="12" lg="6" md="12" v-if="event.location=='In-person'">
                                        <span class="text-lg-h6"><a :href="getUrl()" target="_blank"><v-icon left>mdi-map</v-icon></a>Location</span>
                                        <p><span v-if="event.address">{{ event.address }}</span>&nbsp;<span v-if="event.city">{{ event.city }}</span>&nbsp;<span v-if="event.postal_code">{{ event.postal_code }}</span>&nbsp;{{event.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12" v-if="event.location=='Online'">
                                        <span class="text-lg-h6">{{event.event_link_description}}</span>
                                        <p>A link to the event will be emailed to you.</p>
                                    </v-col>
                                    <v-col cols="12" lg="6" md="12">
                                        <Link :href="baseurl+'/event/'+event.alias">
                                            <v-btn>Event Details</v-btn>
                                        </Link>
                                    </v-col>
                                </v-row>
            </v-card-actions>
            
  
      </v-card>   
    </v-col>
  </template>
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import axios from 'axios'
  
  import { Link } from '@inertiajs/inertia-vue'
  
  export default {
    props: {
      event: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Head,
      Link
    },
    layout: Layout,
    data() {
        return {
            loading:false
        }
    },
    watch: {
    },
    created() {
    },
    methods: {  
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
        prettyTime(x) {
            return x.slice(0, -3).replace(/^[0]/g,"");
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.event.address +','+this.event.city+','+this.event.region+','+this.event.postal_code);

        },
    },
  }
  </script>
  
  <style scoped>
    /* Titles run from three words to a full sentence; holding them to two
       lines keeps every card's poster and details at the same height. The
       full title stays available as hover text and on the detail page. */
    .event-card__title-wrap {
        height: 92px; /* two lines of title plus the link's own padding */
        overflow: hidden;
        align-items: flex-start;
    }
    /* The clamp lives on a span inside the link: the link itself is a flex
       item of the card title, and a flex item ignores -webkit-box. */
    .event-card__title-wrap ::v-deep .event-card__title-link {
        display: block;
        width: 100%;
    }
    .event-card__title {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 1.6rem;
        word-break: break-word;
    }

    /* One fixed band for the poster: portrait and landscape uploads both sit
       inside it, so cards in a row stay the same shape. */
    .event-card__image {
        height: 220px;
        background: #f5f5f5;
        border-radius: 4px;
    }
    .event-card__image--empty {
        border: 1px dashed rgba(86, 3, 84, 0.25);
    }
    </style>
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>